import React, { useState } from 'react';

const FolderManagementModal = ({ folders, onClose, onAdd, onRename, onDelete }) => {
  const [newFolderName, setNewFolderName] = useState('');
  const [editingFolderId, setEditingFolderId] = useState(null);

  const handleAdd = async () => {
    const name = newFolderName.trim();
    if (!name) return;
    await onAdd(name);
    setNewFolderName('');
    onClose();
  };

  const handleRename = async (folderId, value) => {
    const name = value?.trim();
    if (name) await onRename(folderId, name);
    setEditingFolderId(null);
  };

  const handleDelete = async (folderId) => {
    const closed = await onDelete(folderId);
    if (closed) onClose();
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1001
      }}
      onClick={onClose}
    >
      <div
        className="folder-modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'var(--cc-card-bg)',
          borderRadius: '8px',
          padding: '1.5rem',
          maxWidth: '400px',
          width: '90%',
          maxHeight: '80vh',
          overflow: 'auto'
        }}
      >
        <h3 style={{ margin: '0 0 1rem 0', fontSize: '1rem', fontWeight: 600 }}>Manage folders</h3>
        <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1rem' }}>
          <input
            type="text"
            value={newFolderName}
            onChange={(e) => setNewFolderName(e.target.value)}
            placeholder="New folder name"
            style={{
              flex: 1,
              padding: '0.5rem 0.75rem',
              border: '1px solid #d1d5db',
              borderRadius: '0.25rem',
              fontSize: '0.875rem'
            }}
            onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
          />
          <button
            type="button"
            onClick={handleAdd}
            className="btn-primary"
            disabled={!newFolderName.trim()}
          >
            Add
          </button>
        </div>
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {(folders || []).map(f => (
            <li
              key={f.id}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '0.5rem 0',
                borderBottom: '1px solid var(--branding-app-surface-panel-border)'
              }}
            >
              {editingFolderId === f.id ? (
                <input
                  type="text"
                  defaultValue={f.name}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleRename(f.id, e.target.value);
                    if (e.key === 'Escape') setEditingFolderId(null);
                  }}
                  onBlur={(e) => handleRename(f.id, e.target.value)}
                  autoFocus
                  style={{
                    flex: 1,
                    padding: '0.25rem 0.5rem',
                    border: '1px solid var(--branding-app-primary)',
                    borderRadius: '0.25rem',
                    fontSize: '0.875rem'
                  }}
                />
              ) : (
                <>
                  <span style={{ flex: 1 }}>{f.name}</span>
                  <button
                    type="button"
                    onClick={() => setEditingFolderId(f.id)}
                    style={{
                      padding: '0.25rem 0.5rem',
                      fontSize: '0.75rem',
                      background: 'none',
                      border: '1px solid #d1d5db',
                      borderRadius: '0.25rem',
                      cursor: 'pointer'
                    }}
                  >
                    Rename
                  </button>
                  <button
                    type="button"
                    onClick={() => handleDelete(f.id)}
                    style={{
                      padding: '0.25rem 0.5rem',
                      fontSize: '0.75rem',
                      background: '#fef2f2',
                      color: '#dc2626',
                      border: '1px solid #fecaca',
                      borderRadius: '0.25rem',
                      cursor: 'pointer'
                    }}
                  >
                    Delete
                  </button>
                </>
              )}
            </li>
          ))}
        </ul>
        <button
          type="button"
          onClick={onClose}
          className="btn-secondary"
          style={{ marginTop: '1rem', width: '100%' }}
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default FolderManagementModal;
